"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshNftMetadataResponseToJSON = exports.RefreshNftMetadataResponseFromJSONTyped = exports.RefreshNftMetadataResponseFromJSON = void 0;
function RefreshNftMetadataResponseFromJSON(json) {
    return RefreshNftMetadataResponseFromJSONTyped(json, false);
}
exports.RefreshNftMetadataResponseFromJSON = RefreshNftMetadataResponseFromJSON;
function RefreshNftMetadataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'refreshed': json['refreshed'],
        'missingMetadata': json['missingMetadata'],
    };
}
exports.RefreshNftMetadataResponseFromJSONTyped = RefreshNftMetadataResponseFromJSONTyped;
function RefreshNftMetadataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'refreshed': value.refreshed,
        'missingMetadata': value.missingMetadata,
    };
}
exports.RefreshNftMetadataResponseToJSON = RefreshNftMetadataResponseToJSON;
